import React, { Component } from 'react';
import { SVGIcon } from '@custom-components';
import PropTypes from 'prop-types';
import { DialogActions } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { PortalButton } from '../../BuildingBlocks/PortalButton/PortalButton';

import {
  StyledDialog,
  StyledDialogContent,
  StyledCloseButtonWrapper,
  StyledTitleHeader,
  StyledIconeHeader,
  StyledHeaderContainer,
  StyledTitle,
  StyledSubTitle,
  StyledIconWrapper
} from './ErrorModal.styles';
import { logoColor3, colorBlack, colorWhite } from '../../css/colors';
import { WithStylesClassesPropType } from '../../../lib/commonPropTypes';

const styles = () => ({
  paper: {
    boxShadow: 'none',
    borderRadius: 0
  },
  paperNoOverflow: {
    boxShadow: 'none',
    borderRadius: 0,
    overflow: 'visible'
  }
});

class ErrorModal extends Component {
  getActions = () => {
    const { actions } = this.props;
    return actions.map((action, index) => {
      const key = `button${index}`;
      return <PortalButton key={key} {...action} />;
    });
  };

  getTitleHeader = () => {
    const { title, fullContent, subtitle, titleColor } = this.props;

    return (
      <StyledTitleHeader fullContent={fullContent} titleColor={titleColor}>
        <StyledTitle> {title} </StyledTitle>
        <StyledSubTitle>{subtitle}</StyledSubTitle>
      </StyledTitleHeader>
    );
  };

  getIconHeader = () => {
    const { handleClose, closeButton, showClose, errorIcon, iconColor } = this.props;
    const close = (
      <StyledCloseButtonWrapper className="modal-close" onClick={handleClose}>
        {closeButton}
      </StyledCloseButtonWrapper>
    );
    const showError = <StyledIconWrapper iconColor={iconColor}>{errorIcon}</StyledIconWrapper>;

    return (
      <StyledIconeHeader>
        {showClose && close}
        {showError}
      </StyledIconeHeader>
    );
  };

  getHeader = () => {
    const { fullContent, headerColor } = this.props;
    return (
      <StyledHeaderContainer fullContent={fullContent} headerColor={headerColor}>
        {this.getIconHeader()}
        {this.getTitleHeader()}
      </StyledHeaderContainer>
    );
  };

  render() {
    const {
      classes,
      openModal,
      content,
      handleClose,
      actions,
      fullContent,
      disableEnforceFocus,
      children,
      noOverflow
    } = this.props;

    let dialogClassNames = '';
    if (fullContent) dialogClassNames += 'fullContent ';
    if (noOverflow) dialogClassNames += 'noOverflow ';

    return (
      <StyledDialog
        classes={classes.paper}
        open={openModal}
        onClose={handleClose}
        maxWidth={false}
        smallmodal={false}
        className={dialogClassNames}
        disableEnforceFocus={disableEnforceFocus}
      >
        {this.getHeader()}
        <StyledDialogContent className={dialogClassNames}>{content || children}</StyledDialogContent>
        {actions.length !== 0 && (
          <DialogActions style={{ padding: '0px 24px 24px' }}>{this.getActions()}</DialogActions>
        )}
      </StyledDialog>
    );
  }
}

ErrorModal.propTypes = {
  children: WithStylesClassesPropType.isRequired,
  openModal: PropTypes.bool,
  handleClose: PropTypes.func,
  content: PropTypes.node,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func,
      btnTheme: PropTypes.string,
      disabled: PropTypes.bool,
      type: PropTypes.oneOf(['button', 'submit', 'reset', null])
    })
  ),
  smallModal: PropTypes.bool,
  closeButton: PropTypes.node,
  errorIcon: PropTypes.node,
  iconColor: PropTypes.node,
  headerColor: PropTypes.node,
  titleColor: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  showClose: PropTypes.bool,
  fullContent: PropTypes.bool,
  classes: WithStylesClassesPropType.isRequired,
  noOverflow: PropTypes.bool,
  disableEnforceFocus: PropTypes.bool
};

ErrorModal.defaultProps = {
  openModal: false,
  handleClose: () => {},
  content: null,
  actions: [],
  smallModal: false,
  closeButton: <SVGIcon selectedIcon="closeModal" />,
  showClose: true,
  errorIcon: <span>&#9888;</span>,
  iconColor: colorWhite,
  headerColor: logoColor3,
  title: '',
  subtitle: '',
  titleColor: colorBlack,
  fullContent: false,
  noOverflow: false,
  disableEnforceFocus: false
};

const ComposedErrorModal = withStyles(styles)(ErrorModal);
export default ComposedErrorModal;
